import React from 'react';
import PropTypes from 'prop-types';
import './quiz-styles.scss';

/* This component is a box that reads "A PUREWOW QUIZ" and will be rendered above the category + header on all articles that are quizzes. */

const QuizBox = () => (
    <div className="quiz-box-wrapper">
        {/* fix the bullets and why is it making everything not aligned??? */}
        <h2 className="quiz-box-text">
            <span className="dot">&#8226;</span> A PureWow Quiz <span className="dot">&#8226;</span>
        </h2>
    </div>
);

QuizBox.propTypes = {
  className: PropTypes.string,
};

export default QuizBox;
